export default __webpack_public_path__ + "static/media/lep3.4772e061.png";